import { useEffect, useRef } from 'react';
import { ErrorAnalytics } from '../lib/analytics';

/**
 * Hook to track component loading times
 */
export const usePerformanceTracking = (componentName: string) => {
  const startTimeRef = useRef<number>(Date.now());

  useEffect(() => {
    const endTime = Date.now();
    const loadingTime = endTime - startTimeRef.current;
    
    // Only track if loading time is reasonable (> 50ms and < 30s)
    if (loadingTime > 50 && loadingTime < 30000) {
      ErrorAnalytics.loadingTime(componentName, loadingTime);
    }
  }, [componentName]);
};

/**
 * Hook to track search results
 */
export const useSearchTracking = () => {
  const trackNoResults = (query: string, searchType: string) => {
    if (query.trim().length > 0) {
      ErrorAnalytics.searchNoResults(query, searchType);
    }
  };

  return { trackNoResults };
};

/**
 * Hook to track API errors
 */
export const useApiErrorTracking = () => {
  const trackApiError = (endpoint: string, statusCode: number, errorMessage?: string) => {
    ErrorAnalytics.apiError(endpoint, statusCode, errorMessage);
  };

  return { trackApiError };
};

export default {
  usePerformanceTracking,
  useSearchTracking,
  useApiErrorTracking
};